var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"c-nav c-nav--floating-footer-sticky"},[_c('button',{staticClass:"c-button c-button--primary c-button--width-fuid c-button--mobile-small waves-effect",on:{"click":_vm.callValidation}},[_vm._v(" Continuar ")])])}
var staticRenderFns = []

export { render, staticRenderFns }